import { QBox, QText } from '@qualio/ui-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const UnauthorizedView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <QBox p="5" textAlign="center">
      <QText fontSize="3xl">{t('pages.unauthorized.title')}</QText>
      <div>
        <QText pb="2" fontWeight="bold">
          {t('pages.unauthorized.heading')}
        </QText>
        <QText pb="2">{t('pages.unauthorized.message')}</QText>
        <QText>{t('pages.unauthorized.contactSupport')}</QText>
      </div>
    </QBox>
  );
};
